import React from 'react';
import { Navbar, Sidebar } from '../../components';
import ProfileUpdateRequestList from './list';

function ProfileUpdateRequests() {
  return (
    <>
      <Navbar />
      <Sidebar />
      <div className="screen-wrapper">
        <div className="screen-header" style={{ fontFamily: 'Inter, sans-serif' }}>
          <ProfileUpdateRequestList />
        </div>
      </div>
    </>
  );
}

export default ProfileUpdateRequests;
